import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_c("div", {
    staticClass: "container-centered small"
  }, [_c("article", {
    staticClass: "terms-container"
  }, [_c("section", {
    staticClass: "titles"
  }, [_c("label", {
    class: {
      active: _vm.step === 1
    }
  }, [_vm._v("Terms of use")]), _c("i", {
    staticClass: "fas fa-chevron-right"
  }), _c("label", {
    class: {
      active: _vm.step === 2
    }
  }, [_vm._v("Terms of sales")]), _vm.isFirstConnection ? _c("i", {
    staticClass: "fas fa-chevron-right"
  }) : _vm._e(), _vm.isFirstConnection ? _c("label", {
    class: {
      active: _vm.step === 3
    }
  }, [_vm._v("Nearly there...")]) : _vm._e()]), _vm.step === 1 ? _c("section", {
    staticClass: "text-block",
    on: {
      scroll: _vm.handleScroll
    }
  }, [_c("TermsOfUse")], 1) : _vm._e(), _vm.step === 2 ? _c("section", {
    staticClass: "text-block",
    on: {
      scroll: _vm.handleScroll
    }
  }, [_c("TermsOfSales")], 1) : _vm._e(), _vm.step === 1 || _vm.step === 2 ? [_c("div", {
    staticClass: "blur-bar"
  }), _c("div", {
    staticClass: "footer-bar"
  })] : _vm._e(), _c("div", {
    staticClass: "button-end-page-container"
  }, [_c("div", [_vm.step === 1 || _vm.step === 2 ? _c(VBtn, {
    staticClass: "dfwa-btn --with-dark-bg",
    attrs: {
      rounded: true,
      disabled: !_vm.hasScrolledToBottom,
      loading: _vm.isAccepting
    },
    on: {
      click: _vm.accept
    }
  }, [_vm._v(" Accept ")]) : _vm._e(), _c("div", {
    staticClass: "text-italic mt-1"
  }, [_vm._v("Please read all of our terms to accept them")])], 1)])], 2), _vm.isFirstConnection && _vm.step === 3 ? _c("section", [_c("profile", {
    staticClass: "profile-color",
    attrs: {
      firstConnection: _vm.isFirstConnection
    }
  })], 1) : _vm._e()])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };